import styles from './RadioGroup.module.scss';

interface IRadioGroupProps {
  selectedOption: boolean;
  firstLabel: string;
  secondLabel: string;
  onChange: () => void;
}

function RadioGroup({ selectedOption, firstLabel, secondLabel, onChange }: IRadioGroupProps) {
  return (
    <div className={styles.radioContainer}>
      <label>
        <input type="radio" name="groupName" value="option1" checked={selectedOption} onChange={onChange} />
        {firstLabel}
      </label>

      <label>
        <input type="radio" name="groupName" value="option2" checked={!selectedOption} onChange={onChange} />
        {secondLabel}
      </label>
    </div>
  );
}

export default RadioGroup;
